export const getAppTheme = state => state.general && state.general.theme;

export const getSendMail = state => state.general && state.general.sendMail;

export const getSuperUserLicenseTypesSelector = state =>
  state && state.general && state.general.licenseTypes;

export const getUserTypesSelector = state =>
  state && state.general && state.general.userTypes;

export const getIndustrySector = state => state?.general?.industrySector;
